// LP（app/views/reservation_lp/**）の view が読む JS（#2311）。
// ESM でビルドし（package.json の build:lp）、view から <script type="module"> で読む。
// モジュールは文書ごとに 1 回しか評価されないので、下の turbo:load の listener も 1 回だけ登録される
// （本文のクラシック <script> にすると、Turbo が描画のたびに作り直して再実行し、listener が積み上がる）。
import EmblaCarousel from 'embla-carousel'
import AutoScroll from 'embla-carousel-auto-scroll'

declare global {
  interface Window {
    openModal?: (modalId: string) => void
    closeModal?: (modalId: string) => void
    setCalendarStickyContainerHeight?: () => void
  }
}

document.addEventListener('turbo:load', function () {
  document.querySelectorAll<HTMLElement>('.slow-slider-container').forEach(function (slider) {
    EmblaCarousel(slider, { loop: true }, [AutoScroll({ playOnInit: true, speed: 0.5 })])
  })
})

// モーダルを開く
document.addEventListener('turbo:load', function () {
  window.openModal = function (modalId) {
    const modal = document.getElementById(modalId)
    if (modal) {
      modal.classList.remove('hidden')
    }
  }
})

// モーダルを閉じる
document.addEventListener('turbo:load', function () {
  window.closeModal = function (modalId) {
    const modal = document.getElementById(modalId)
    if (modal) {
      modal.classList.add('hidden')
    }
  }
})

// Set calendar sticky container height to info block height
window.setCalendarStickyContainerHeight = function () {
  const contentWrapper = document.querySelector<HTMLElement>('.content-wrapper')
  const calendarStickyContainer = document.getElementById('calendar-sticky-container')
  if (contentWrapper && calendarStickyContainer) {
    const contentWrapperHeight = contentWrapper.offsetHeight
    const calendarHeight = calendarStickyContainer.offsetHeight

    if (contentWrapperHeight > calendarHeight) {
      calendarStickyContainer.style.height = contentWrapperHeight + 'px'
    }
  }
}

document.addEventListener('turbo:load', function () {
  window.setCalendarStickyContainerHeight?.()
})
